// Human-friendly time helpers for the event timeline.

export function timeAgo(iso) {
  if (!iso) return null;
  const t = new Date(iso).getTime();
  if (Number.isNaN(t)) return null;
  const s = Math.floor((Date.now() - t) / 1000);
  if (s < 0) return "in the future";
  if (s < 60) return "just now";
  const m = Math.floor(s / 60);
  if (m < 60) return `${m}m ago`;
  const h = Math.floor(m / 60);
  if (h < 48) return `${h}h ago`;
  const d = Math.floor(h / 24);
  if (d < 30) return `${d}d ago`;
  const mo = Math.floor(d / 30);
  if (mo < 12) return `${mo}mo ago`;
  return `${Math.floor(mo / 12)}y ago`;
}

export function fmtAbs(iso) {
  if (!iso) return "—";
  const dt = new Date(iso);
  if (Number.isNaN(dt.getTime())) return "—";
  return dt.toISOString().replace("T", " ").slice(0, 16) + " UTC";
}

// Detection latency: seconds between when an event occurred and when Vigilo Earth flagged it.
export function latencySeconds(observed, detected) {
  if (!observed || !detected) return null;
  const o = new Date(observed).getTime();
  const d = new Date(detected).getTime();
  if (Number.isNaN(o) || Number.isNaN(d)) return null;
  const s = (d - o) / 1000;
  return s >= 0 ? s : null;
}

export function fmtDuration(seconds) {
  if (seconds == null || Number.isNaN(seconds)) return null;
  if (seconds < 60) return `${Math.round(seconds)}s`;
  const m = Math.round(seconds / 60);
  if (m < 60) return `${m}m`;
  const h = Math.floor(m / 60);
  const rm = m % 60;
  if (h < 48) return rm ? `${h}h ${rm}m` : `${h}h`;
  const d = Math.floor(h / 24);
  return `${d}d`;
}

// Colour a latency by responsiveness: fast (<1h) green, hours amber, slow (>6h) orange.
export function latencyTone(seconds) {
  if (seconds == null) return "text-atlas-secondary";
  if (seconds < 3600) return "text-emerald-400";
  if (seconds < 6 * 3600) return "text-amber-300";
  return "text-atlas-orange";
}
